
/* JUMPSEAT – Dynamischer Versandfortschritt */

(() => {
  let currentCart = null;
  let updateScheduled = false;

  function getShippingTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return null;
    }

    let total = 0;

    for (const item of cart.items) {
      if (item.requires_shipping) {
        total += Number(item.final_line_price) || 0;
      }
    }

    for (const discount of
      cart.cart_level_discount_applications || []) {
      total -= Number(discount.total_allocated_amount) || 0;
    }

    return Math.max(0, total);
  }

  function updateProgress() {
    const updatedTotal = getShippingTotal(currentCart);

    document.querySelectorAll(
      '.jumpseat-shipping-progress[data-goal-cents]'
    ).forEach(bar => {

      const goal = Number(bar.dataset.goalCents);

      const total = updatedTotal !== null
        ? updatedTotal
        : Number(bar.dataset.totalCents);

      if (
        !Number.isFinite(goal) ||
        goal <= 0 ||
        !Number.isFinite(total)
      ) return;

      const percent = Math.min(
        100,
        Math.max(0, (total / goal) * 100)
      );

      const fill = bar.querySelector(
        '.jumpseat-shipping-progress-fill'
      );

      if (!fill) return;

      fill.style.width = `${percent}%`;

      bar.setAttribute(
        'aria-valuenow',
        String(Math.round(percent))
      );
    });
  }

  function scheduleUpdate() {
    if (updateScheduled) return;

    updateScheduled = true;

    requestAnimationFrame(() => {
      updateScheduled = false;
      updateProgress();
    });
  }

  // Prestige meldet Änderungen am Warenkorb.
  document.addEventListener('cart:change', event => {
    currentCart = event.detail?.cart || null;
    scheduleUpdate();
  });

  // Auch neu geladene Cart-Drawer-Inhalte erfassen.
  const observer = new MutationObserver(scheduleUpdate);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleUpdate,
      { once: true }
    );
  } else {
    scheduleUpdate();
  }
})();
